module.exports = __webpack_public_path__ + "img/zuijia_24.3db21233.png";